/* eslint-disable */

export var BleMessageSubscriber = {
  foundDevices: [],
  readVal: {},
  _origin: '*',
  _callbacks: {},
  _ble: {},
  _separator: '::',
  _prefix: 'ble::',
  initialize: function(ble, origin) {
    this._origin = origin || this._origin
    this._ble = ble
    window.addEventListener('message', this._receiveMessage.bind(this))
  },
  init: function(handleSuccess, handleError) {
    var args = [
      this._addCallback(handleSuccess),
      this._addCallback(handleError)
    ]
    this._sendMessageToBle('init', args)
  },
  startScan: function(addDevice, handleError, params) {
    var args = [
      this._addCallback(addDevice),
      this._addCallback(handleError),
      params
    ]
    this._sendMessageToBle('startScan', args)
  },
  stopScan: function(handleSuccess, handleError) {
    var args = [
      this._addCallback(handleSuccess),
      this._addCallback(handleError)
    ]
    this._sendMessageToBle('stopScan', args)
  },
  connect: function(
    address,
    handleSuccess,
    handleError,
    disconnectCallback,
    params
  ) {
    var args = [
      address,
      this._addCallback(handleSuccess),
      this._addCallback(handleError),
      this._addCallback(disconnectCallback),
      params
    ]
    this._sendMessageToBle('connect', args)
  },
  close: function(address, handleSuccess, handleError) {
    var args = [
      address,
      this._addCallback(handleSuccess),
      this._addCallback(handleError)
    ]
    this._sendMessageToBle('close', args)
  },
  disconnect: function(address, handleSuccess, handleError) {
    var args = [
      address,
      this._addCallback(handleSuccess),
      this._addCallback(handleError)
    ]
    this._sendMessageToBle('disconnect', args)
  },
  addReceivedValueListener: function(address, listener) {
    var args = [address, this._addCallback(listener)]
    this._sendMessageToBle('addReceivedValueListener', args)
  },
  requestValue: function(address, handleSuccess, handleError) {
    var args = [
      address,
      this._addCallback(handleSuccess),
      this._addCallback(handleError)
    ]
    this._sendMessageToBle('requestValue', args)
  },
  changeNC1BLEConfig: function(address, handleSuccess, handleError, params) {
    var args = [
      address,
      this._addCallback(handleSuccess),
      this._addCallback(handleError),
      params
    ]
    this._sendMessageToBle('changeNC1BLEConfig', args)
  },
  isNumber1Device: function(name) {
    return this._ble.isNumber1Device(name)
  },
  isNumber2Device: function(name) {
    return this._ble.isNumber2Device(name)
  },
  isNumber3Device: function(name) {
    return this._ble.isNumber3Device(name)
  },
  isNumber4Device: function(name) {
    return this._ble.isNumber4Device(name)
  },
  isNumber5Device: function(name) {
    return this._ble.isNumber5Device(name)
  },
  isNumber6Device: function(name) {
    return this._ble.isNumber6Device(name)
  },
  isNumber7Device: function(name) {
    return this._ble.isNumber7Device(name)
  },
  isNumber9Device: function(name) {
    return this._ble.isNumber9Device(name)
  },
  isNumber10Device: function(name) {
    return this._ble.isNumber10Device(name)
  },
  //functions for postMessage
  _sendMessageToBle(functionName, args) {
    this._sendMessage(functionName + this._separator + JSON.stringify(args))
  },
  _sendMessage: function(data) {
    /*
    data = `${ble function name}:${args as JSON}`
    callback function must be replaced id string
    ex: 'startScan:[4, "1897s4", "16890i9"]'
    */
    //console.log('BleMessageSubscriber sendMessage data =>', this._prefix + data)
    window.parent.postMessage(this._prefix + data, this._origin)
  },
  _receiveMessage: function(event) {
    /*
    event.data = `${runCallback}:${callback id}:${args as JSON must be array} `
    event.data = `${setProperty}:${propertyName}:${arg as JSON} `
    ex: '1897s4:["string", { a: "ok"}]'
    */
    //console.log('BleMessageSubscriber receiveMessage from', event.origin, event)
    //console.log('BleMessageSubscriber receiveMessage data =>', event.data)
    if (this._origin != '*' && event.origin !== this._origin)
      throw new Error('CORS Error')
    try {
      if (!this._checkMessage(event.data)) return
      var message = event.data.replace(this._prefix, '')
      var type = this._getDataFromMessage(message).type
      var data = this._getDataFromMessage(message).data
      switch (type) {
        case 'setProperty':
          var name = data[0]
          var value = JSON.parse(data[1])
          this._setProperty(name, value)
          break
        case 'runCallback':
          var callbackId = data[0]
          var args = JSON.parse(data[1])
          this._runCallback(callbackId, args)
          break
        default:
          console.log(event.data)
      }
    } catch (e) {
      console.log(e)
    }
  },
  _addCallback: function(callback) {
    var id = this._generateUuid()
    this._callbacks[id] = callback
    return id
  },
  _setProperty(name, value) {
    this[name] = value
  },
  _runCallback(id, args) {
    if (typeof this._callbacks[id] === 'function') {
      this._callbacks[id].apply(null, args)
    }
  },
  _generateUuid: function() {
    return 'callback-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/x/g, () => Math.floor(Math.random() * 16).toString(16))
      .replace(/y/g, () => (Math.floor(Math.random() * 4) + 8).toString(16))
  },
  _getDataFromMessage(message) {
    var datas = message.split(this._separator)
    return {
      type: datas[0],
      data: datas.slice(1)
    }
  },
  _checkMessage(message) {
    var reg = new RegExp(
      '^' +
        this._prefix +
        '.+' +
        this._separator +
        '.+' +
        this._separator +
        '.+'
    )
    return reg.test(message)
  }
}

var BleMessagePublisher = {
  _targetWindow: {},
  _ble: {},
  _separator: '::',
  _prefix: 'ble::',
  initialize: function(ble, _origin, targetWindow) {
    this._targetWindow = targetWindow
    this._ble = ble
    this._ble.onChangeFoundDevices = this._handleChangeFoundDevices.bind(this)
    this._ble.onChangeReadVal = this._handleReadVal.bind(this)
    this._origin = _origin || this._origin
    window.addEventListener('message', this._receiveMessage.bind(this))
  },
  _handleChangeFoundDevices: function() {
    this._sendMessage(
      'setProperty' +
        this._separator +
        'foundDevices' +
        this._separator +
        JSON.stringify(this._ble.foundDevices)
    )
  },
  _handleReadVal: function() {
    this._sendMessage(
      'setProperty' +
        this._separator +
        'readVal' +
        this._separator +
        JSON.stringify(this._ble.readVal)
    )
  },
  _sendMessage: function(data) {
    /*
    data = `${runCallback}:${callback id}:${args as JSON must be array} `
    data = `${setProperty}:${propertyName}:${arg as JSON} `
    ex: '1897s4:["string", { a: "ok"}]'
    */
    this._targetWindow.postMessage(this._prefix + data, this._origin)
  },
  _receiveMessage: function(event) {
    /*
    event.data = `${ble function name}:${args as JSON}`
    callback function must be replaced id string
    ex: 'startScan:[4, "1897s4", "16890i9"]'
    */
    if (this._origin != '*' && event.origin !== this._origin)
      throw new Error('CORS Error')
    try {
      if (!this._checkMessage(event.data)) return
      var message = event.data.replace(this._prefix, '')
      var data = this._getDataFromMessage(message)
      var functionName = data.functionName
      var args = data.args

      this._ble[functionName].apply(this._ble, args)
    } catch (e) {
      console.log(e)
    }
  },
  _runCallback: function(id, args) {
    this._sendMessage(
      'runCallback' +
        this._separator +
        id +
        this._separator +
        JSON.stringify(args)
    )
  },
  _getDataFromMessage(message) {
    var functionName = message.split(this._separator)[0]
    var args = JSON.parse(message.split(this._separator)[1])
    if (!Array.isArray(args)) throw new Error('args is no Array:' + args)
    if (!(functionName in this._ble))
      throw new Error(
        'doesnt exist such name of function at ble:' + functionName
      )
    var me = this
    var argList = args.map(function(arg) {
      if (typeof arg === 'string' && /^callback-/.test(arg)) {
        return function() {
          me._runCallback(arg, Array.from(arguments))
        }
      }
      return arg
    })
    return {
      functionName: functionName,
      args: argList
    }
  },
  _checkMessage(message) {
    var reg = new RegExp('^' + this._prefix + '.+' + this._separator + '.+')
    return reg.test(message)
  }
}
